<template>
  <v-row dense>
    <v-col cols="12">
      <div style="width: 100%; height: 100%;">
        <canvas ref="gaugeChart" class="mx-auto"></canvas>
        <!-- <div class="d-flex justify-space-between mx-auto px-2">
            <div>
              <v-icon :color="$coreScores.getColor(1)" small>
                {{ $coreScores.getIcon(1) }}
              </v-icon>
            </div>
            <div class="text-h5">
              {{ $coreScores.format(coreCard.value) | no_decimal }}
            </div><div>
              <v-icon :color="$coreScores.getColor(10)" small>
                {{ $coreScores.getIcon(10) }}
              </v-icon>
            </div> 
          </div>-->
      </div>
    </v-col>
    <v-col cols="12" class="text-center text-h5 secondary--text">
      {{ $coreScores.format(coreCard.value) | no_decimal }}
    </v-col>
  </v-row>
</template>

<script>
import Chart from "chart.js";
import "chartjs-gauge";
export default {
  name: "CoreCardPulse",
  props: { coreCard: { type: Object } },
  data: () => ({ gauge: null }),
  watch: {
    coreCard() {
      this.updateChart();
    }
  },
  computed: {},
  mounted() {
    this.updateChart();
  },
  methods: {
    updateChart() {
      if (this.chart) {
        this.chart.destroy();
      }
      if (!this.coreCard.value) {
        return;
      }
      this.chart = new Chart(this.$refs.gaugeChart, {
        type: "gauge",
        data: {
          datasets: [
            {
              data: [100],
              value: this.$coreScores.format(this.coreCard.value),
              backgroundColor: [this.$vuetify.theme.themes.light.secondary],
              borderWidth: 0
            }
          ]
        },
        options: {
          hover: { mode: null },
          responsive: true,
          cutoutPercentage: 90,
          tooltips: {
            enabled: false
          },
          layout: {
            padding: {
              bottom: 10
            }
          },
          needle: {
            // Needle circle radius as the percentage of the chart area width
            radiusPercentage: 2,
            // Needle width as the percentage of the chart area width
            widthPercentage: 3.2,
            // Needle length as the percentage of the interval between inner radius (0%) and outer radius (100%) of the arc
            lengthPercentage: -20,
            // The color of the needle
            color: this.$vuetify.theme.themes.light.secondary
          },
          valueLabel: {
            display: false
          },
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              display: false
            }
          }
        }
      });
    }
  }
};
</script>
